<template>
    <div class="ml-2">
        <b-button variant="danger" @click.stop="abrirModal()">
            <i class="fa fa-times-circle"></i> Devolver Solicitação
        </b-button>
        <b-modal
            :visible="mostrarModal"
            @hide="fecharModal"
            hide-footer
            title="Devolver Requisição a um Solicitante"
            centered
        >
            <b-alert v-if="erros.length" variant="danger" show>
                <div v-for="(erro, idx) in erros" :key="idx">{{ erro }}</div>
            </b-alert>
            <b-form-group
                label="Devolver ao Licitante"
                label-for="licitante-input"
                label-class="required"
            >
                <model-select
                    :options="licitantesOpcoes"
                    v-model="CodResponsavelDevolucao"
                    placeholder="Pesquisar por nome..."
                ></model-select>
            </b-form-group>
            <b-form-group
                label="Justificativa"
                label-for="justificativa-input"
                label-class="required"
            >
                <b-form-textarea
                    id="justificativa-input"
                    v-model="justificativa"
                    :rows="4"
                    :limit="1000"
                    placeholder="Informe a justificativa"
                ></b-form-textarea>
            </b-form-group>
            <div class="d-flex justify-content-end">
                <b-button variant="secondary" class="mr-2" @click="fecharModal"
                    >Cancelar</b-button
                >
                <b-button
                    variant="danger"
                    :disabled="!justificativaPreenchida"
                    @click="reprovarSolicitacao"
                    >Devolver</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import RequisicoesServicos from './RequisicoesServicos'

export default {
    components: {
        ModelSelect
    },
    props: {
        requisicao: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            mostrarModal: false,
            justificativa: '',
            CodResponsavelDevolucao: null,
            licitantes: [],
            erros: []
        }
    },
    methods: {
        abrirModal() {
            this.justificativa = ''
            this.CodResponsavelDevolucao = null
            this.erros = []
            this.mostrarModal = true
            this.obterLicitantes()
        },
        fecharModal() {
            this.mostrarModal = false
        },
        reprovarSolicitacao() {
            this.erros = []
            if (!this.CodResponsavelDevolucao) {
                this.erros.push('O licitante é obrigatório.')
                return
            }
            if (!this.justificativa || this.justificativa.trim() === '') {
                this.erros.push('A justificativa é obrigatória.')
                return
            }
            this.$store.dispatch('addRequest')
            const idRequisicao = this.$route.params.idRequisicao
            RequisicoesServicos.reprovarSolicitacaoRequisicao({
                idRequisicao: idRequisicao,
                justificativa: this.justificativa,
                codResponsavelDevolucao: this.CodResponsavelDevolucao
            }).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$emit('obterRequisicaoAtualizada')
                        this.$store.dispatch('setRecarregar', true)
                        this.$toast.success(
                            'Solicitação devolvida com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.mostrarModal = false
                    } else {
                        this.erros = response.errors || [
                            'Erro ao reprovar a solicitação.'
                        ]
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        obterLicitantes() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterSolicitantes().then((response) => {
                if (response) {
                    if (response.success) {
                        this.licitantes = response.data
                    } else {
                        this.erros.push('Erro ao obter licitantes')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },
    computed: {
        justificativaPreenchida() {
            return (
                this.CodResponsavelDevolucao != null &&
                this.justificativa != null && this.justificativa.trim() !== ''
            )
        },
        licitantesOpcoes() {
            return [...this.licitantes]
                .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' }))
                .map((l) => ({ value: l.codFuncionario, text: l.nome }))
        }
    }
}
</script>
